import React, { Component } from 'react';
import {Card, Table, Modal, Button, Input, Form, Transfer, Select} from 'antd';
import {
    auditViewAdd,
    auditViewDelete,
    auditViewDeletes,
    auditViewListInitDataSource,
    auditViewUpdate, getActivitiFlow
} from "../actions/auditViewList";
import {uuid} from "../utils";
import {connect} from "react-redux";
const { Option } = Select;
const start = 1;//从1第一页开始
const size = 10;//每页10条

/** 列表 */
class AuditViewList extends Component {
    columns = [
        {
            title: '视角名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <a onClick={()=>this.updateAuditView(record)}>{text}</a>
            ),
        },
        {
            title: '流程名称',
            dataIndex: 'activitiName',
            key: 'activitiName'
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
                <span>
					<Button type="primary" onClick={()=>this.updateAuditView(record)}>修改</Button>
                    <Button type="primary" style={{marginLeft:"10px"}} onClick={()=>this.showAuditViewNodeModal(record)}>编辑流程节点</Button>
					<Button type="danger" style={{marginLeft:"10px"}} onClick={()=>this.deleteAuditView([record])}>删除</Button>
				</span>
            ),
        }
    ];

    state = {
        start : start,
        size : size,
        total: 0,
        selectedRows:[],
        data: []
    };

    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    paginationOnChange(page, pageSize){
        auditViewListInitDataSource(page, pageSize, (res)=>{
            this.setState(prevState => {
                return {
                    ...prevState,
                    start : page,
                    size : pageSize,
                    total: res.count,
                    data: (()=>{
                        for(let i = 0; res.data && i < res.data.length; i++){
                            //这个key是react的item必须的，如果没有这会按照索引来。但是复选框就会出问题了。
                            //当选择了某个选项，再翻页后，会将新页码中的数据也选中
                            if(!res.data[i].key){
                                res.data[i].key = res.data[i].id;
                            }
                        }
                        return res.data;
                    })(),
                    selectedRows:[]
                }
            })
        });
    }

    componentDidMount() {
        this.initDataSource(this.state.start, this.state.size);
    }

    onSelect = (record, selected, selectedRows, nativeEvent)=>{
        this.setState({
            selectedRows: selectedRows
        })
    };

    onSelectAll = (selected, selectedRows, changeRows) => {
        this.setState({
            selectedRows: selectedRows
        })
    };

    updateAuditView = (auditView) => {
        this.refs.auditViewModal.showModal("修改", auditView, auditViewUpdate, ()=>{
            //这里要刷新导航，所以直接刷新页面
            window.location.search = new Date().getTime();
            // this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    addAuditView = () => {
        this.refs.auditViewModal.showModal("新增", null, auditViewAdd, ()=>{
            //这里要刷新导航，所以直接刷新页面
            window.location.search = new Date().getTime();
            // this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    deleteAuditView = (selectedRows) => {
        let that = this;
        if(!selectedRows || selectedRows.length === 0){
            Modal.error({
                title: '请选择要删除的项',
                okText:"确定"
            });
            return;
        }
        Modal.confirm({
            title: '删除审核视角',
            content: '删除后无法恢复，确定删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: ()=>{
                let ids = [];
                for(let i = 0; selectedRows && i < selectedRows.length; i ++){
                    let id = selectedRows[i].id;
                    ids.push(id);
                }
                if(ids && ids.length === 1){
                    auditViewDelete({id:ids[0]},()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState(prevState =>{
                        let tempSelectedRows = [];
                        for(let j = 0; prevState.selectedRows && j < prevState.selectedRows.length; j ++){
                            let row = prevState.selectedRows[j];
                            if(row.id !== ids[0]){
                                tempSelectedRows.push(row);
                            }
                        }
                        return {
                            ...prevState,
                            selectedRows:tempSelectedRows
                        };
                    })
                }else if(ids && ids.length > 1){
                    auditViewDeletes(ids,()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState({
                        selectedRows:[]
                    });
                }
                //这里要刷新导航，所以直接刷新页面
                window.location.search = new Date().getTime();
            }
        });
    };

    //获取选中的项，用于回显
    getSelectedRowKeys = ()=>{
        let selectedRowKeys = [];
        for(let j = 0; this.state.selectedRows && j < this.state.selectedRows.length; j ++){
            let row = this.state.selectedRows[j];
            selectedRowKeys.push(row.key);
        }
        return selectedRowKeys;
    };

    showAuditViewNodeModal(auditView){
        this.refs.auditViewNodeModal.showModal("编辑流程节点弹窗", auditView, (activitiName, nodeId, callBack)=>{
            auditView.nodeId = nodeId;
            auditView.activitiName = activitiName;
            auditViewUpdate(auditView, ()=>this.paginationOnChange(this.state.start, this.state.size));
            callBack();
        },  ()=>{});
    }

    render() {
        const margin = 15;
        const type = "checkbox";//也可以是radio
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.start,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        let selectedRowKeys = this.getSelectedRowKeys();
        let activitiType = this.props.match.params.type;
        let {mediaCode} =  this.props.match.params;
        return (
            <Card title={<span style={{fontSize: "14px"}}>审核视角列表</span>} style={{ width: "calc(100% - "+margin*2+"px)", margin: margin + "px"}}>
                <Button type="primary" onClick={()=>this.addAuditView()}>新增</Button>
                <Button type="danger" style={{marginLeft:"10px",marginBottom:"20px"}} onClick={()=>this.deleteAuditView(this.state.selectedRows)}>批量删除</Button>
                <AuditViewModal ref={"auditViewModal"} activitiType={activitiType} mediaCode={mediaCode} />
                <AuditViewNodeModal currentAccount={!this.props.currentUser?"":this.props.currentUser.account} ref={"auditViewNodeModal"} activitiType={activitiType} mediaCode={mediaCode} />
                <Table columns={this.columns} dataSource={this.state.data} pagination={pagination}
                       rowSelection={{
                           selectedRowKeys: selectedRowKeys,
                           onSelect: this.onSelect,
                           onSelectAll: this.onSelectAll,
                           type: type
                       }}
                       bordered={true}//是否展示外边框和列边框
                       size={"small"}/>
            </Card>
        );
    }
}

/** 弹窗 */
class AuditViewModal extends React.Component{

    state = {
        title: "信息",
        visible: false,
        fieldData: {},
        confirmLoading: false,
    };

    closeBallBack(){

    };
    okCallBack(){

    };

    showModal = (title, fieldData, okCallBack, closeCallBack) => {
        this.setState({
            title: title,
            visible: true,
            fieldData: (()=>{
                if(!fieldData){
                    return null;
                }
                let value = {};
                for(let attr in fieldData){
                    value[attr] = {
                        value: fieldData[attr]
                    }
                }
                return value;
            })()
        });
        this.okCallBack = okCallBack;
        this.closeBallBack = closeCallBack;
    };

    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });

        let that = this;
        let wrappedAuditViewModalForm = this.refs.wrappedAuditViewModalForm;//通过refs属性可以获得对话框内form对象
        wrappedAuditViewModalForm.validateFields((err, values) => {
            if(!err){
                values.activitiType = this.props.activitiType;
                values.mediaCode = this.props.mediaCode;
                that.okCallBack(values, function(){
                    that.setState({
                        visible: false,
                        confirmLoading: false,
                    });
                    wrappedAuditViewModalForm.resetFields();
                    if(that.closeBallBack){
                        that.closeBallBack();
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = () => {
        let wrappedAuditViewModalForm = this.refs.wrappedAuditViewModalForm;
        wrappedAuditViewModalForm.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title={this.state.title}
                visible={visible}
                onOk={this.handleOk}
                okText={"确定"}
                maskClosable={true}
                cancelText={"取消"}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <WrappedAuditViewModalForm fieldData={this.state.fieldData} ref={"wrappedAuditViewModalForm"} />
            </Modal>
        );
    }
}

/** 表单 */
class AuditViewModalForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return (
            <Form {...formItemLayout}>
                {getFieldDecorator('id',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
                <Form.Item label="视角名称">
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入视角名称!' }],
                    })(
                        <Input placeholder="请输入视角名称" />
                    )}
                </Form.Item>
                {getFieldDecorator('mediaCode', {
                })(
                    <Input type={"hidden"} placeholder="请输入媒体编码" />
                )}
                {getFieldDecorator('activitiType', {
                })(
                    <Input type={"hidden"} placeholder="请输入流程类型" />
                )}
            </Form>
        );
    }
}

const WrappedAuditViewModalForm = Form.create()(AuditViewModalForm);


/** 编辑流程节点弹窗 */
class AuditViewNodeModal extends React.Component{

    isInit = false;
    componentWillReceiveProps(nextProps, nextContext) {
        console.log("this.state.activitiFlow==componentWillReceiveProps====", this.state.activitiFlow);
        if(nextProps.currentAccount && !this.isInit){
            this.isInit = true;//为了保证下面只请求一次,造成资源浪费
            getActivitiFlow(this.props.activitiType, nextProps.currentAccount,(data)=>{
                this.setState({activitiFlow: data});

                if(this.auditView && this.auditView.activitiName){
                    this.handleActivitiChange(this.auditView.activitiName);
                }
            });
        }
    }

    state = {
        title: "编辑流程节点",
        visible: false,
        fieldData: {},
        confirmLoading: false,
        mockData: [],
        targetKeys: [],
        activitiFlow:[]
    };

    closeCallBack(){

    };
    okCallBack(){

    };

    auditView;
    appName;

    showModal = (title, auditView, okCallBack, closeCallBack) => {
        this.setState({
            title: title,
            visible: true,
        });
        this.auditView = auditView;
        this.handleActivitiChange(this.auditView.activitiName);
        this.okCallBack = okCallBack;
        this.closeCallBack = closeCallBack;
    };

    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });
        this.okCallBack(this.appName, this.state.targetKeys, ()=>{
            this.setState({
                visible: false,
                confirmLoading: false,
            });
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.closeCallBack();
    };

    getMock = (nodes) => {
        const targetKeys = [];
        const mockData = [];
        for (let i = 0; nodes && i < nodes.length; i++) {
            const data = {
                key: nodes[i].nodeId,
                title: nodes[i].nodeName,
                chosen: this.auditView.nodeId && (this.auditView.nodeId.indexOf(nodes[i].nodeId) !== -1),
            };
            if (data.chosen) {
                targetKeys.push(data.key);
            }
            mockData.push(data);
        }
        this.setState({ mockData, targetKeys });
    };

    filterOption = (inputValue, option) => option.title.indexOf(inputValue) > -1;

    handleChange = targetKeys => {
        this.setState({ targetKeys });
    };

    handleSearch = (dir, value) => {
    };

    //流程图切换的时候
    handleActivitiChange = value => {
        this.state.activitiFlow.map(item=>{
           if(item.appName === value){
               this.appName = value;
               this.getMock(item.nodes);
           }
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title={this.state.title}
                visible={visible}
                onOk={this.handleOk}
                width={"900px"}
                okText={"确定"}
                maskClosable={true}
                cancelText={"取消"}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                {
                    (this.auditView&&this.auditView.activitiName)?this.auditView.activitiName:
                        <Select
                            placeholder={"请选择流程图"}
                            size={"default"}
                            style={{ width: '30%' }}
                            onChange={this.handleActivitiChange}
                        >
                            {this.state.activitiFlow.map(item=>{
                                let appName = item.appName?item.appName:"流程图名称为空,请联系管理员.";
                                return <Option key={uuid()} value={appName}>{appName}</Option>
                            })}
                        </Select>
                }
                <Transfer
                    listStyle={{
                        width: 400,
                        height: 500,
                    }}
                    dataSource={this.state.mockData}
                    showSearch
                    filterOption={this.filterOption}
                    targetKeys={this.state.targetKeys}
                    onChange={this.handleChange}
                    onSearch={this.handleSearch}
                    render={item => item.title}
                />
            </Modal>
        );
    }
}


function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser
    }
}

export default connect(mapStateToProps)(AuditViewList);